export default {
    EMPLOYEE(state, items) {
        state.items = items
    }
}